import React, {
  createContext,
  useState,
  useEffect
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getStoredSettings, storeSettings } from 'src/utils/settings';
import configService from 'src/services/configService';
import { THEMES } from 'src/submodules/commons-misc/constant';

const SettingsContext = createContext();


export function SettingsProvider({ settings, children }) {

  const defaultSettings = {
      direction: 'ltr',
      responsiveFontSizes: true,
      theme: THEMES.POST.name,
      language:localStorage.getItem('i18nextLng')
  };

  const [currentSettings, setCurrentSettings] = useState(settings || getStoredSettings() || defaultSettings);
  const handleSaveSettings = (updatedSettings = {}) => {
    const mergedSettings = _.merge({}, currentSettings, updatedSettings);

    setCurrentSettings(mergedSettings);
    storeSettings(mergedSettings);
  };

  useEffect(() => {
    document.dir = currentSettings.direction;
  }, [currentSettings]);

  configService.getConfig();

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        saveSettings: handleSaveSettings
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

SettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  settings: PropTypes.object
};

export const SettingsConsumer = SettingsContext.Consumer;

export default SettingsContext;
